module.exports = __webpack_public_path__ + "static/media/student-score-50p.9e8e0913.png";